import invoke from "../utils/invoke";

export const generatePdf = async (amount, userCourses, isSecondEnrolment = false) => {
  const data = await invoke({
    url: `/users/generate-pdf/${isSecondEnrolment}`,
    method: "POST",
    data: {amount, userCourses},
  });
  return data;
};
export const applyForScholarship = async (formData) => {
  const data = await invoke({
    url: `/scholarship/apply`,
    method: "POST",
    data: formData,
  });
  return data;
};

export const submitTestResults = async (testData) => {
  const data = await invoke({
    url: `/users/test`,
    method: "POST",
    data: testData,
  });
  return data;
};

export const getUserProfile = async () => {
  const data = await invoke({
    url: `/users/profile`,
    method: "GET",
  });
  return data;
};

export const submitContactForm = async (contactData) => {
  const data = await invoke({
    url: `/contact/contact`,
    method: "POST",
    headers: { "x-api-key": "12345678" },
    data: contactData,
  });
  return data;
};

export const submitSecondEnrolledCourses = async (courses) => {
  const data = await invoke({
    url: `/users/second-enrolled-courses`,
    method: "POST",
    data: { courses },
  });
  return data;
};

export const submitAdmitCardData = async (formData) => {
  const data = await invoke({
    url: `/admit-card/submit`,
    method: "POST",
    data: formData,
  });
  return data;
};

export const getMyAdmitCardData = async () => {
  const data = await invoke({
    url: `/admit-card/mine`,
    method: "GET",
  });
  return data;
};

export const getAdmitCardConfig = async () => {
  const data = await invoke({
    url: `/settings/admit-card-config`,
    method: "GET",
  });
  return data;
};

export const updateUserProfile = async (profileData) => {
  const data = await invoke({
    url: `/users/profile`,
    method: "PUT",
    data: profileData,
  });
  return data;
};
